import React, { useState, useEffect } from 'react';
import { createClassesAndGroups, fetchTerms } from '../utils/api';
import { mapErrorMessage } from '../utils/errorMapping';

const CreateClassesAndGroupsModal = ({ onClose, onCreated }) => {
    const [terms, setTerms] = useState([]);
    const [selectedTerm, setSelectedTerm] = useState('');
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const termsData = await fetchTerms();
                setTerms(termsData.data);
            } catch (error) {
                setError(mapErrorMessage(error.message));
            }
        };
        fetchData();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccess(null);
        try {
            await createClassesAndGroups(parseInt(selectedTerm));
            setSuccess('Classes and groups created successfully!');
            onCreated();
        } catch (error) {
            setError(mapErrorMessage(error.message));
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Create Classes & Groups</h2>
                {error && <div className="error-message">{error}</div>}
                {success && <div className="success-message">{success}</div>}
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <select value={selectedTerm} onChange={(e) => setSelectedTerm(e.target.value)} required>
                            <option value="">Select Term</option>
                            {terms.map(term => (
                                <option key={term.id} value={term.id}>{term.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="actions-centered">
                        <button type="button" className="cancel-button text-button" onClick={onClose}>Cancel</button>
                        <button type="submit" className="submit-button text-button">Create</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateClassesAndGroupsModal;